"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientKpi = void 0;
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const react_1 = require("react");
const React = require("react");
require("./patient-kpi.less");
class PatientKpi extends react_1.Component {
    render() {
        const { patientKpi = { name: "", nextAppt: undefined, orders: 0, total: 0 } } = this.props;
        return (React.createElement("div", { className: "patient-kpi" },
            React.createElement(kpi_title_1.KpiTitle, { label: patientKpi.name })));
    }
}
exports.PatientKpi = PatientKpi;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/components/patient-kpi/patient-kpi.tsx
// module id = 3801
// module chunks = 0